import { render, staticRenderFns } from "./Complemento.vue?vue&type=template&id=3a5964c6&"
import script from "./Complemento.vue?vue&type=script&lang=js&"
export * from "./Complemento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports